import { createTheme } from '@mui/material/styles';

// Get CSS variable values from the :root
const rootStyles = getComputedStyle(document.documentElement);
const buttonBg = rootStyles.getPropertyValue('--button-bg').trim() || '#E1ECE2';
const buttonText = rootStyles.getPropertyValue('--button-text').trim() || '#333333';
const background = rootStyles.getPropertyValue('--background').trim() || '#FAFAFA';
const headerBg = rootStyles.getPropertyValue('--header-bg').trim() || '#E1ECE2';
const textColor = rootStyles.getPropertyValue('--text-color').trim() || '#4B4B4B';
const headerText = rootStyles.getPropertyValue('--header-text').trim() || '#333333';
const tableRow1 = rootStyles.getPropertyValue('--table-row-1').trim() || '#F0F8F0';
const tableRow2 = rootStyles.getPropertyValue('--table-row-2').trim() || '#F9FDF9';

// Detect RTL from document direction
const isRTL = document.documentElement.dir === 'rtl' || document.documentElement.getAttribute('dir') === 'rtl';

const theme = createTheme({
  direction: isRTL ? 'rtl' : 'ltr',
  palette: {
    primary: {
      main: buttonBg,
      contrastText: buttonText,
    },
    background: {
      default: background,
      paper: headerBg,
    },
    text: {
      primary: textColor,
    },
  },
  components: {
    MuiTableRow: {
      styleOverrides: {
        root: {
          '&:nth-of-type(odd)': {
            backgroundColor: tableRow1,
          },
          '&:nth-of-type(even)': {
            backgroundColor: tableRow2,
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: headerBg,
          color: headerText,
          textAlign: 'center',
        },
        body: {
          textAlign: 'center',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          backgroundColor: buttonBg,
          color: buttonText,
          '&:hover': {
            backgroundColor: '#cfdad1',
          },
        },
        root: {
          '& .MuiButton-startIcon': {
            marginRight: isRTL ? '8px' : undefined,
            marginLeft: isRTL ? undefined : '8px',
          },
          '& .MuiButton-endIcon': {
            marginLeft: isRTL ? '8px' : undefined,
            marginRight: isRTL ? undefined : '8px',
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: '#333333',
          '&.Mui-focused': {
            color: '#333333',
          },
        },
      },
    },
  },
});

export default theme;

